import React, { useState, useEffect } from "react";
import { DatePicker } from 'antd-mobile';
import { Radios } from '../components';
import { getDateRange, getRangeDatesOfDate, renderDate, timeFormatType } from '../utils/timeFormat';

const defaultMinDate = new Date(+new Date() - 31536000000)//默认最小时间 一年前
const defaultMaxDate = new Date()
/**
* 带快捷键的时间范围封装，主要参数value、onChange，类似一个Input组件
* @param dateList 快捷键，来源于DateRange中的key
* @param rangePickerOptions 时间范围组件的参数
* @param defaultRangeBtn 默认时间键，仅展示，不带时间赋值，赋值字段为value
*/
function DateRangeButton(props) {

    const { dateList, onChange, showTime, defaultRangeBtn, format, minDate, maxDate, style } = props;

    const [rangeBtn, setRangeBtn] = useState(defaultRangeBtn);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [calendarVisible, setCalendarVisible] = useState(false);

    const options = dateList.map(item => (
        { label: item, value: item }
    ))

    useEffect(() => {
        if (startDate && endDate) {
            let rangeDates = [startDate, endDate];
            if (!showTime) {
                // 开始时间取0点，结束时间取23:59:59
                rangeDates = getRangeDatesOfDate(rangeDates)
            }
            onChange(rangeDates, rangeBtn);
        }
    }, [startDate, endDate])

    const onRadioChange = value => {
        setRangeBtn(value);
        if (value !== "自定义") {
            const dateRange = getDateRange(value);
            onChange(dateRange, value);
        }
        setCalendarVisible(value === "自定义")
    };

    return (
        <div style={style}>
            <Radios
                options={[...options, { label: "自定义", value: "自定义" }]}
                onChange={onRadioChange}
                value={rangeBtn}
                style={{ marginRight: "8px" }}
            />
            {calendarVisible ? <span style={{ margin: "8px 0" }}>
                <DatePicker
                    mode="date"
                    title="开始时间"
                    style={{ display: 'inline' }}
                    value={startDate}
                    onChange={v => setStartDate(v)}
                    minDate={minDate || defaultMinDate}
                    maxDate={endDate || maxDate || defaultMaxDate}
                >
                    <span>
                        <span>开始时间：</span>
                        {startDate ?
                            renderDate(startDate, format || timeFormatType.date) :
                            <span className="a-blue">请选择</span>}
                    </span>
                </DatePicker>
                <DatePicker
                    mode="date"
                    title="结束时间"
                    style={{ display: 'inline' }}
                    value={endDate}
                    onChange={v => setEndDate(v)}
                    minDate={startDate || minDate || defaultMinDate}
                    maxDate={maxDate || defaultMaxDate}
                >
                    <span>
                        <span>结束时间：</span>
                        {endDate ?
                            renderDate(endDate, format || timeFormatType.date) :
                            <span className="a-blue">请选择</span>}
                    </span>
                </DatePicker>
            </span> : null}
        </div>
    )
}

export default DateRangeButton